import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateQuantity } from '../../../store/cartSlice';
//import { Link } from 'react-router-dom';
import ShopNav from '../../../components/shopNav/ShopNav';
import Footer from '../../../components/footer/footer';
import { useLocation, useNavigate } from 'react-router-dom';
import { setPreviousRoute } from '../../../store/navigationSlice';
import NavCategorias from '../../../components/navbar/NavCategorias';
import ServiceHighlights from '../../../components/servicehighlights/ServiceHighlights';
import ProductImageGallery from '../../../components/shop/ProductImageGallery';

import './cartDetail.css';

// Función para formatear el precio en COP
const formatCOP = (value) => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value)
}

const CartDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart);
  const user = useSelector(state => state.auth.user);

  // Previene que Enter recargue el form mientras un modal estuviera abierto
  useEffect(() => {
    const preventFormReloadOnEnter = (e) => {
      const modalOpen = document.body.classList.contains('modal-open');
      if (modalOpen && e.key === 'Enter') {
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', preventFormReloadOnEnter);
    return () => {
      document.removeEventListener('keydown', preventFormReloadOnEnter);
    };
  }, []);

  const totalCOP = cart.items.reduce((acc, item) => {
    return acc + (item.quantity * parseFloat(item.priceCOP || 0));
  }, 0);

  return (
    <div className="cart-page">
      <ShopNav />
      <NavCategorias />
      <main className="cart-page-main">
        <section className="cart-page-hero cart-page-elevated-wrap cart-page-elevated-wrap--hero">
          <div className="container cart-page-hero-inner">
            <div className="cart-page-hero-copy">
              <h1 className="display-5 animate__animated animate__fadeIn">Detalles del carrito</h1>
              <p className="lead animate__animated animate__fadeIn">
                Revisa tus productos, ajusta cantidades y finaliza tu compra con una experiencia clara y segura.
              </p>
            </div>
            <div className="cart-page-hero-logo-wrap animate__animated animate__fadeIn" aria-hidden="true">
              <img src="/images/VPA.png" alt="Vintage Pro Audio" className="cart-page-hero-logo" />
            </div>
          </div>
        </section>

        <section className="cart-page-elevated-wrap">
          <ServiceHighlights />
        </section>

        <section className="container mb-5 cart-detail-page cart-page-results">
          <div className="cart-page-results-head">
            <h2 className="cart-page-results-title">Resumen de tu pedido</h2>
            <p className="cart-page-results-meta">{cart.items.length} producto(s) en el carrito</p>
          </div>

          {cart.items.length === 0 ? (
            <div className="alert alert-warning text-center cart-empty-state">El carrito está vacío</div>
          ) : (
            <div className="row g-3 cart-items-grid">
              {cart.items.map(item => {
                return (
                  <div key={item.id} className="col-12">
                    <article className="card border-0 cart-item-card">
                      <div className="card-body cart-item-card-body">
                        <div className="row g-3 align-items-stretch">
                          <div className="col-lg-5 col-md-6 col-12 mb-2 mb-md-0">
                            <div className="cart-image-gallery-wrapper">
                              <ProductImageGallery
                                imageUrl={item.imageUrl}
                                productName={item.name}
                                showPlayButton={false}
                                showFullscreenButton={false}
                                showThumbnails={false}
                                autoPlay={true}
                                slideInterval={4000}
                              />
                            </div>
                          </div>

                          <div className="col-lg-7 col-md-6 col-12 d-flex flex-column cart-item-info">
                            <h5 className="card-title fw-bold cart-item-title">{item.name}</h5>

                            <p className="mb-1 text-muted small cart-item-brand">
                              <i className="bi bi-tag me-1"></i>{item.brand?.name || 'Sin marca'}
                            </p>

                            <div className="d-flex align-items-center gap-2 mb-2 cart-item-badges">
                              <span className="badge text-uppercase cart-chip cart-chip-category">
                                {item.category || 'Sin categoría'}
                              </span>
                              <span className="badge text-uppercase cart-chip cart-chip-subcategory">
                                {item.subcategory || 'Sin subcategoría'}
                              </span>
                            </div>


                            <p className="text-muted small mb-1 cart-item-description">{item.description}</p>
                            <p className="text-muted small mb-2 cart-item-description-secondary">{item.additionalDescription}</p>

                            <ul className="list-unstyled small mb-3 cart-item-meta-list">
                              <li className="cart-meta-row"><strong>Peso:</strong> <span>{item.weight} lb</span></li>
                              <li className="cart-meta-row">
                                <strong>Stock:</strong>
                                {item.stock === 0 ? (
                                  <span className="ms-2 text-danger fw-bold fst-italic cart-stock-warning">
                                    Podemos conseguirlo rápidamente.
                                  </span>
                                ) : (
                                  <span className="ms-2 fw-semibold text-success cart-stock-ok">
                                    {item.quantity}
                                  </span>
                                )}
                              </li>

                              <li className="cart-meta-row cart-meta-row-qty">
                                <strong>Cantidad:</strong>
                                <select
                                  className="form-select form-select-sm w-auto d-inline-block ms-2 cart-qty-select"
                                  value={item.quantity}
                                  onChange={(e) =>
                                    dispatch(updateQuantity({ id: item.id, quantity: parseInt(e.target.value) }))
                                  }
                                >
                                  {[...Array(10).keys()].map(i => (
                                    <option key={i + 1} value={i + 1}>
                                      {i + 1}
                                    </option>
                                  ))}
                                </select>
                              </li>

                              <li className="cart-meta-row cart-meta-row-price">
                                <strong>Precio unidad (COP):</strong>{' '}
                                <span className="text-success fw-bold fs-5 cart-unit-price">
                                  {formatCOP(item.priceCOP)}
                                </span>
                              </li>
                            </ul>

                            <div className="mt-auto text-end cart-subtotal-wrap">
                              <h6 className="fw-bold text-success fs-5 cart-subtotal-value">
                                Subtotal: {formatCOP(item.quantity * item.priceCOP)}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                );
              })}

              <div className="col-12 mt-4">
                <div className="text-center cart-total-wrap cart-total-panel">
                  <h4 className="fw-bold text-success mb-4 cart-total-value">
                    Total del Carrito (COP): {formatCOP(totalCOP)}
                  </h4>

                  {cart.items.length > 0 && (
                    <div className="mt-3">
                      {user ? (
                        <button
                          className="btn btn-success btn-lg cart-checkout-btn"
                          onClick={() => (window.location.href = '/checkout')}
                        >
                          <i className="bi bi-credit-card me-2"></i>Proceder al Pago
                        </button>
                      ) : (
                        <>
                          <p className="text-muted mb-3 cart-login-hint">
                            Inicia sesión o regístrate para continuar con el pago
                          </p>
                          <div className="d-flex justify-content-center gap-2 cart-auth-actions">
                            <button
                              className="btn cart-auth-btn cart-auth-btn-login"
                              onClick={() => {
                                dispatch(setPreviousRoute(location));
                                navigate('/loginVpStore');
                              }}
                            >
                              <i className="bi bi-person-circle me-1"></i>Iniciar Sesión
                            </button>
                            <button
                              className="btn cart-auth-btn cart-auth-btn-register"
                              onClick={() => {
                                dispatch(setPreviousRoute(location));
                                navigate('/registerVpStore');
                              }}
                            >
                              <i className="bi bi-person-plus-fill me-1"></i>Registrarse
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  )}

                  <hr className="mt-4" />
                  </div>
                </div>
            </div>
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CartDetail;
